<template>
  <v-container fluid>
    <v-layout justify-center>
      <v-flex xs12>
        <v-card class="pa-3">
          <v-card-title>
            {{title}}
          </v-card-title>
          <v-form ref="templateForm">
            <v-layout row wrap>
              <v-flex xs12 md8>
                <v-text-field
                  :readonly="(status==='readonly')"
                  :disabled="(status==='readonly')"
                  prepend-icon="mdi-format-title"
                  label="模板标题"
                  :rules="$rules.required('标题不能为空')"
                  v-model="templateInfo.name"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md4>
                <v-select
                  :single-line="(status==='readonly') && !templateInfo.type"
                  :readonly="!(status==='new')"
                  :disabled="!(status==='new')"
                  prepend-icon="mdi-bookmark"
                  label="模板类型"
                  :rules="(status==='new') ? $rules.required('必须选择模板类型'):[]"
                  :items="['sms']"
                  hint="首次提交后不可更改"
                  v-model="templateInfo.type"
                ></v-select>
              </v-flex>
              <!--<v-flex xs12 md4>-->
              <!--<select-datetime-->
              <!--label="编辑时间"-->
              <!--v-model="templateInfo.name"-->
              <!--&gt;</select-datetime>-->
              <!--</v-flex>-->
              <v-flex xs12 md4>
                <v-text-field
                  :readonly="(status==='readonly')"
                  :disabled="(status==='readonly')"
                  prepend-icon="mdi-code-tags"
                  label="模板编码"
                  v-model="templateInfo.code"
                  :rules="$rules.required('模板编码不能为空')"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md4>
                <v-select
                  :single-line="(status==='new') && !templateInfo.module"
                  :readonly="!(status==='new')"
                  :disabled="!(status==='new')"
                  prepend-icon="mdi-view-grid"
                  label="所属模块"
                  :rules="(status==='new') ? $rules.required('必须选择所属模块'):[]"
                  :items="moduleList"
                  item-text="text"
                  item-value="value"
                  hint="首次提交后不可更改"
                  v-model="templateInfo.module"
                ></v-select>
              </v-flex>
              <v-flex xs12 md4>
                <v-text-field
                  disabled
                  prepend-icon="mdi-account"
                  label="操作人"
                  v-model="templateInfo.editor"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <!--<v-form ref="tempText" v-model="templateValid">-->
                <v-textarea
                  :readonly="!(status==='new')"
                  :disabled="!(status==='new')"
                  prepend-icon="mdi-note-text"
                  label="模板原文"
                  v-model="templateInfo.originalTemplate"
                  :rows="1"
                  :rules="(status==='new')?templateRules:[]"
                  :hint="(status==='new')?'使用“{}”包裹的内容将标记为变量，由于短信运营商限制，模板中请勿使用 ‘{’ 和 ‘}’':'首次提交后不可更改'"
                  auto-grow
                ></v-textarea>
                <!--</v-form>-->
              </v-flex>
            </v-layout>
          </v-form>
          <v-form ref="varsForm">
            <v-layout row wrap class="pt-2">
              <v-flex :key="index" xs12 v-for="(v, index) in variables">
                <v-layout align-center row>
                  <v-flex xs3>
                    <v-text-field
                      label="变量名"
                      :readonly="!(status==='new')"
                      :disabled="!(status==='new')"
                      :rules="$rules.required('不能为空')"
                      prepend-icon=" "
                      v-model="v.key"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs7>
                    <v-select
                      :readonly="!(status==='new')"
                      :disabled="!(status==='new')"
                      :items="moduleLabelSelect"
                      label="变量内容"
                      item-text="id"
                      :rules="$rules.required('必须选择变量内容')"
                      :hint="(moduleLabelSelect.find(l => l.id === v.value) || {}).description || ''"
                      persistent-hint
                      item-value="id"
                      v-model="v.value"
                    >
                      <template
                        slot="item"
                        slot-scope="data"
                      >
                        <v-list-tile-content>
                          <v-list-tile-title>{{data.item.id}}</v-list-tile-title>
                          <v-list-tile-sub-title>{{data.item.description}}</v-list-tile-sub-title>
                        </v-list-tile-content>
                      </template>
                    </v-select>
                  </v-flex>
                  <v-flex>
                    <v-tooltip right>
                      <v-fab-transition slot="activator">
                        <v-btn v-if="(status==='edit') || (status==='new')" @click="deleteVariable(index)" icon>
                          <v-icon>mdi-close</v-icon>
                        </v-btn>
                      </v-fab-transition>
                      <span>删除变量</span>
                    </v-tooltip>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-form>
          <v-card-actions>
            <v-btn class="primary" v-if="status==='new'||status==='edit'" @click="submitTemplate" :loading="loading">提交</v-btn>
            <v-btn class="primary" v-if="status==='readonly'" @click="status='edit'">修改</v-btn>
            <v-btn color="grey" v-if="status==='edit'" @click="status='readonly'" class="white--text">取消</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import _ from 'lodash'
import F from '../../../ladmin/utils/functional'
let variablePattern = /({[^{}]+})/g
function testBraceClose (text) {
  if (!text) return true
  let stack = []
  const IN = '{'
  const OUT = '}'
  for (let i = 0; i < text.length; ++i) {
    if (text[i] === IN) {
      stack.push(IN)
    }
    else if (text[i] === OUT) {
      if (stack.length > 0) {
        stack.pop()
      }
      else {
        return false
      }
    }
  }
  return stack.length === 0
}

function haveNestBrace (text) {
  if (!text) return true
  let stack = []
  const IN = '{'
  const OUT = '}'
  for (let i = 0; i < text.length; ++i) {
    if (text[i] === IN) {
      stack.push(IN)
    }
    else if (text[i] === OUT) {
      stack.pop()
      if (stack.length !== 0) {
        return true
      }
    }
  }
  return false
}
var cloneObj = function (obj) {
  var newObj = {}
  if (obj instanceof Array) {
    newObj = []
  }
  for (var key in obj) {
    var val = obj[key]
    // newObj[key] = typeof val === 'object' ? arguments.callee(val) : val; //arguments.callee 在哪一个函数中运行，它就代表哪个函数, 一般用在匿名函数中。
    newObj[key] = typeof val === 'object' ? cloneObj(val) : val
  }
  return newObj
}
export default {
  name: 'smsMessageDetail',
  props: {
    statusProp: {
      type: String,
      default: 'new'
    },
    idProp:{
      type:String,
      default: ''
    }
  },
  data () {
    return {
      loading: false,
      status: 'new',
      templateInfo: {
        code: '',
        createTime: '',
        editor: '',
        enable: 1,
        id: '',
        module: '',
        lastUpdateTimestamp: '',
        name: '',
        originalTemplate: '',
        templateJson: {},
        type: null,
      },
      infoChanged: false,
      moduleLabels: [],
      templateRules: [
        v => !!v || '模板内容不能为空!',
        v => testBraceClose(v) || '模板中不能含有‘{’ 和 ‘}’作为字符使用',
        v => !haveNestBrace(v) || '模板中不能含有嵌套的‘{}’',
        v => !/{}/g.test(v) || '变量名不能为空',
        v => !(v.match(variablePattern) || [])
          .sort()
          .some((t, i, A) => i < A.length - 1 ? A[i] === A[i + 1]
            : false) || '不能含有相同的变量名',
      ],
      variables: [],
      passJson: {
        'status': 1,
        'msg': '200 OK',
        'data': {
          'PASS|ORDER_ORG': '来访人单位',
          'PASS|ORDER_ID_CARD': '来访人身份证号',
          'PASS|OWNER_PHONE': '受访人电话',
          'PASS|ORDER_PHONE': '来访人电话',
          'PASS|ORDER_OBJECT_CODE': '访客车牌',
          'IM|NOW': '格式为YYYY-MM-DD HH:mm:ss',
          'IM|CURRENT_USER': '根据用户TOKEN获取执行操作用户的用户名',
          'PASS|ORDER_PASS_TIME': '预约时段',
          'PASS|ORDER_NAME': '来访人姓名',
          'PASS|ORDER_PARKLOT': '预约园区',
          'PASS|OWNER_NAME': '受访人姓名'
        }
      },
      vioJson: {
        'status': 1,
        'msg': '200 OK',
        'data': {
          'VIO|OBJECT_CODE': '车牌',
          'VIO|AREA': '违章区域',
          'VIO|VIOLATOR_CODE': '违章用户编码（教工号）信息',
          'IM|NOW': '格式为YYYY-MM-DD HH:mm:ss',
          'IM|CURRENT_USER': '根据用户TOKEN获取执行操作用户的用户名',
          'VIO|VIOLATION': '违章内容',
          'VIO|VIOLATOR_ORG': '该参数依赖于VIO|VIOLATOR,获取违章用户单位信息',
          'VIO|VIOLATION_HISTORY': '历史违章',
          'VIO|FREEZE_INFO': '冻结说明',
          'VIO|TIMES': '违章次数',
          'VIO|MSG': '附加描述'
        }
      }
    }
  },
  created () {
    console.log('created')
    this.init()
  },
  methods: {
    init () {
      if (this.$route.query.status !== undefined) {
        this.status = this.$route.query.status
      }else{
        this.status = this.statusProp
      }
      if (this.status === 'readonly') {
        this.getTemplateInfo(this.idProp)
      }
    },
    async getTemplateInfo (id) {
      let searchParam = {
        'searchParam': {
          'id': {
            'keyword': id,
            'order': 'ASC'
          }
        }
      }
      let pagination = {
        page: 0,
        rowsPerPage: 10
      }
      let res = await this.$store.dispatch('messageManagement/getTemplateList', {pagination: pagination, searchParam: searchParam})
      if (res.data.status === 1) {
        this.dealTemplateInfo(res.data.data.content[0])
      }
    },
    dealTemplateInfo (item) {
      this.templateInfo = item
      let json = eval('(' + this.templateInfo.templateJson + ')')
      let vars = this.variables
      if (json instanceof Object) {
        for (let key of Object.keys(json)) {
          vars.push({key: key.slice(1, -1), value: json[key], content: ''})
        }
        console.log('init variables', this.variables)
      }
    },
    getModuleLabels () {
      // console.log(this.templateInfo.module)
      let module = this.templateInfo.module
      if (module === 'pass') {
        let obj = this.passJson.data
        for (let i in obj) {
          let item = {
            text: obj[i], value: i
          }
          this.moduleLabels.push(item)
        }
      }
      else {
        let obj = this.vioJson.data
        for (let j in obj) {
          let item = {
            text: obj[j], value: j
          }
          this.moduleLabels.push(item)
        }
      }
    },
    async submitTemplate () {
      if (this.$refs.templateForm.validate() && this.$refs.varsForm.validate()) {
        let addition = {}
        for (let v of this.variables) {
          addition[`{${v.key}}`] = v.value
        }
        let templateInfo = {
          'id': '',
          'name': this.templateInfo.name,
          'code': this.templateInfo.code,
          'type': this.templateInfo.type,
          'module': this.templateInfo.module,
          'originalTemplate': this.templateInfo.originalTemplate,
          'addition': JSON.stringify(addition)
        }
        console.log(templateInfo)
        this.loading = true
        let res = await this.$store.dispatch('messageManagement/addTemplate', templateInfo)
        this.loading = false
        if (res.data.status === 1) {
          this.$L.alert('success', {message: (this.status === 'new') ? '添加成功' : '修改成功'})
          this.status = 'readOnly'
        }
        else {
          this.$L.alert('error', {message: '添加失败，原因：' + res.data.msg})
        }
      }
      else {
        this.$L.alert('error', {message: '表单数据不合法'})
      }
    },
    deleteVariable (i) {
      let varNames = this.variables.map(v => v.key)
      let name = varNames[i]
      this.templateInfo.originalTemplate = this.templateInfo.originalTemplate.replace('{' + name + '}', '')
      // console.log('delete', name, this.templateInfo.originalTemplate)
    },
  },
  computed: {
    moduleList () {
      return this.$store.state.messageManagement.moduleList
    },
    moduleLabelSelect () {
      let select = []
      for (let label of this.moduleLabels) {
        select.push({id: label.value, description: label.text, avatar: '__PLACEHOLDER__'})
      }
      // console.log('get selections', select)
      if (select.length === 0) {
        if (this.templateInfo.module) {
          select.push({header: '该模块下没有可选变量'})
        }
        else {
          select.push({header: '请先选择所属模块'})
        }
      }
      return select
    },
    title () {
      if (this.status === 'new') {
        return '添加模板'
      }
      else if (this.status === 'edit') {
        return '编辑模板'
      }
      else if (this.status === 'readonly') {
        return '查看模板'
      }
    }
  },
  watch: {
    'templateInfo.originalTemplate': function (val, oldVal) {
      if (!val) {
        this.variables = []
        return
      }
      let names = val.match(variablePattern) || []
      // console.log('text match', names)

      // 如果变量部分没变，直接返回
      if (oldVal) {
        let oldNames = oldVal.match(variablePattern) || []
        let equal = true
        names.forEach((name, i) => {
          if (name !== oldNames[i]) equal = false
        })
        if (equal && oldNames.length === names.length) return
      }

      // 去除名称的大括号
      names.forEach((name, i) => {
        // console.log(name, name.slice(1, -1))
        names[i] = name.slice(1, -1)
      })

      // 如果变量数组中的名字和text提取的一样，直接返回
      // 避免watch循环修改
      let varNames = this.variables.map(v => v.name)
      let vEqual = true
      names.forEach((name, i) => {
        if (name !== varNames[i]) vEqual = false
      })
      if (vEqual && names.length === varNames.length) return

      let newVariables = []
      for (let name of names) {
        let t = this.variables.find(v => v.key === name)
        let temp = null
        if (t) {
          temp = t
        }
        else {
          let v = {key: name, value: ''}
          temp = v
        }

        if (newVariables.find(v => v.key === temp.key)) {
          newVariables.push(Object.assign(temp))
        }
        else {
          newVariables.push(temp)
        }
      }
      this.variables = newVariables
      console.log('variable changed')
    },
    variables: {
      handler: _.debounce(function (val) {
        if (!(this.templateInfo instanceof Object && this.templateInfo.originalTemplate)) {
          return
        }
        if (this.variables.some(v => !v.key)) {
          return
        }
        if (!val) return

        this.infoChanged = true

        let names = this.templateInfo.originalTemplate.match(variablePattern) || []
        let varNames = this.variables.map(v => '{' + v.key + '}')

        console.log('ready to change', Object.assign(names), Object.assign(varNames))

        let t = this.templateInfo.originalTemplate
        let newText = ''

        if (names.length !== varNames.length) {
          console.log(names.length)
          console.log(varNames.length)
          console.error('变量个数与模板中不一致')
        }

        for (let i = 0; i < names.length; ++i) {
          let idx = t.indexOf(names[i])
          newText += t.slice(0, idx + names[i].length).replace(names[i], varNames[i])
          // console.log(`replace ${idx + names[i].length}`, t.slice(0, idx + names[i].length), names[i], varNames[i])
          t = t.slice(idx + names[i].length)
        }
        newText += t
        this.templateInfo.text = newText
      }, 200),
      deep: true
    },
    'templateInfo.module': function (val, oldVal) {
      this.getModuleLabels()
    },
    templateInfo: {
      handler () {
        this.infoChanged = true
      },
      deep: true
    }
  },
}
</script>
